"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLeverageButton = useLeverageButton;
var _react = require("react");
var _reactRedux = require("react-redux");
var _modalActions = require("../../../../redux/actions/modalActions");
var _futuresLeverageSelectors = require("../../../../redux/futures/selectors/futuresLeverageSelectors");
var _selectors = require("../../../../redux/futures/selectors");
var _actions = require("../../../../redux/futures/actions");
// https://www.bybit.com/en/help-center/article/How-to-Open-a-Position
// "The default order will use Cross Margin with 10x leverage in One-Way Mode."
var DEFAULT_FUTURES_LEVERAGE_VALUE = 10;
function useLeverageButton(formName) {
  var leverage = (0, _reactRedux.useSelector)(_futuresLeverageSelectors.currentFuturesLeverageSelector);
  var max = (0, _reactRedux.useSelector)(_futuresLeverageSelectors.futuresMaxLeverageSelector);
  var submitting = (0, _reactRedux.useSelector)(_futuresLeverageSelectors.futuresLeverageSubmittingSelector);
  var isLoadingPositions = (0, _reactRedux.useSelector)(_selectors.isLoadingOpenPositionsSelector);
  var positionLeverage = (0, _reactRedux.useSelector)(_futuresLeverageSelectors.currentPositionLeverageSelector);
  var noLeverage = !leverage;
  var disabled = max <= 2 || leverage <= 1 || noLeverage || submitting;
  var dispatch = (0, _reactRedux.useDispatch)();

  // Reset the leverage value to default when no position is loaded
  (0, _react.useEffect)(function () {
    if (!isLoadingPositions && !positionLeverage && !leverage) {
      dispatch((0, _actions.setFuturesLeverage)(DEFAULT_FUTURES_LEVERAGE_VALUE));
    }
  }, [isLoadingPositions, positionLeverage, leverage, dispatch]);
  var onClick = (0, _react.useCallback)(function () {
    dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.FUTURES_LEVERAGE, {
      formName: formName
    }));
  }, [dispatch, formName]);
  return {
    leverage: leverage !== null && leverage !== void 0 ? leverage : DEFAULT_FUTURES_LEVERAGE_VALUE,
    noLeverage: noLeverage,
    disabled: disabled,
    onClick: onClick
  };
}